import { toast } from 'react-toastify';
import { requestService } from '../services';
import { requestConst, urlConst } from '../consts';
import { processFailure, showErrorsIfNeed } from './utils';
import { history } from '../history';

const URL_PREFIX = process.env.PUBLIC_URL;

export const requestsActions = {
    getAll,
    add,
    updateData,
    addUser,
    rmUser,
    updateUser,
    addComment,
    readComment,
    addFile,
    rmFile,
    bindFileToUser,
    saveExtData,
    clearErrors,
    clear,
    addLink,
    updateCurrentEventAndUpdateRequests,
    getAllDelayed,
};

let requestTimeout;

function add(requestData) {
    return (dispatch, getState) => {
        const initialEventName = startRequestAndGetEventName(dispatch, getState);

        requestService.addRequest(requestData).then(
            (requests) => {
                processUserRequests(requests, initialEventName, true, dispatch, getState);
                toast.success(`Заявка создана`);
                const req = requests.author[requests.author.length - 1];
                history.push(`${URL_PREFIX}/${urlConst.REQUESTS}/${req.num}`);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function getAll() {
    return (dispatch, getState) => {
        resetRequestTimeout();
        const {
            requests: { eventName },
        } = getState();
        requestService.getRequests(eventName).then(
            (requests) => {
                processUserRequests(requests, eventName, false, dispatch, getState);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function updateData(fieldData) {
    return (dispatch, getState) => {
        const initialEventName = startRequestAndGetEventName(dispatch, getState);

        requestService.updateData(fieldData).then(
            (requests) => {
                processUserRequests(requests, initialEventName, true, dispatch, getState);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function addUser(userData) {
    return (dispatch, getState) => {
        const initialEventName = startRequestAndGetEventName(dispatch, getState);

        requestService.addReqUser(userData).then(
            (requests) => {
                processUserRequests(requests, initialEventName, true, dispatch, getState);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function rmUser(userData) {
    return (dispatch, getState) => {
        const initialEventName = startRequestAndGetEventName(dispatch, getState);

        requestService.rmReqUser(userData).then(
            (requests) => {
                processUserRequests(requests, initialEventName, true, dispatch, getState);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function updateUser(userData) {
    return (dispatch, getState) => {
        const initialEventName = startRequestAndGetEventName(dispatch, getState);

        requestService.updateReqUser(userData).then(
            (requests) => {
                processUserRequests(requests, initialEventName, true, dispatch, getState);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function addComment(commentData) {
    return (dispatch, getState) => {
        const initialEventName = startRequestAndGetEventName(dispatch, getState);

        requestService.addComment(commentData).then(
            (requests) => {
                processUserRequests(requests, initialEventName, true, dispatch, getState);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function readComment(commentId) {
    return (dispatch, getState) => {
        resetRequestTimeout();
        const {
            requests: { eventName: initialEventName },
        } = getState();

        requestService.readComment(commentId).then(
            (requests) => {
                processUserRequests(requests, initialEventName, false, dispatch, getState);
            },
            (error) => onError(error, dispatch)
        );
    };
}

/**
 * Добавляет файл в заявку.
 * @deprecated Данный метод не используется. Вместо него необходимо использовать
 *             uploadActions.addFile, который кроме добавления файла еще создает миниатюры.
 * @param {*} fileData
 * @returns
 */
function addFile(fileData) {
    return (dispatch, getState) => {
        const initialEventName = startRequestAndGetEventName(dispatch, getState);

        requestService.addReqFile(fileData).then(
            (requests) => {
                processUserRequests(requests, initialEventName, true, dispatch, getState);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function rmFile(fileData) {
    return (dispatch, getState) => {
        const initialEventName = startRequestAndGetEventName(dispatch, getState);

        requestService.rmReqFile(fileData).then(
            (requests) => {
                processUserRequests(requests, initialEventName, true, dispatch, getState);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function bindFileToUser(data) {
    return (dispatch, getState) => {
        const initialEventName = startRequestAndGetEventName(dispatch, getState);

        requestService.bindReqFileToUser(data).then(
            (requests) => {
                processUserRequests(requests, initialEventName, true, dispatch, getState);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function saveExtData(extData) {
    return (dispatch, getState) => {
        const initialEventName = startRequestAndGetEventName(dispatch, getState);

        requestService.saveExtData(extData).then(
            (requests) => {
                processUserRequests(requests, initialEventName, true, dispatch, getState);
                toast.success(`Данные сохранены`);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function addLink(fileData) {
    return (dispatch, getState) => {
        const initialEventName = startRequestAndGetEventName(dispatch, getState);

        requestService.addReqFileLink(fileData).then(
            (requests) => {
                processUserRequests(requests, initialEventName, true, dispatch, getState);
            },
            (error) => onError(error, dispatch)
        );
    };
}

function clearErrors() {
    return { type: requestConst.CLEAR_ERRORS };
}

function clear() {
    return { type: requestConst.CLEAR };
}

function startRequest() {
    return { type: requestConst.REQUESTS_START_REQUEST };
}

function requestsSuccess(requests) {
    return { type: requestConst.REQUESTS_SUCCESS, requests };
}

function endRequest() {
    return { type: requestConst.REQUESTS_END_REQUEST };
}

function startRequestAndGetEventName(dispatch, getState) {
    resetRequestTimeout();
    dispatch(startRequest());
    const {
        requests: { eventName },
    } = getState();
    return eventName || '';
}

export function processUserRequests(requests, initialEventName, needResetGetting, dispatch, getState) {
    initialEventName = initialEventName || '';
    const {
        requests: { requests: oldRequests },
    } = getState();
    const currentEventName = getState()?.requests?.eventName || '';
    const currentServerTS = (oldRequests && oldRequests.serverTS) || 0;
    if (initialEventName === currentEventName && currentServerTS <= requests.serverTS) {
        dispatch(requestsSuccess(requests));
    } else {
        console.log(
            'server TS in response < actual serverTS. Skip requests packet.',
            requests.serverTS,
            currentServerTS,
            initialEventName,
            currentEventName
        );
    }
    if (needResetGetting) dispatch(endRequest());
}

function onError(error, dispatch) {
    let errors;
    console.error(error);
    if (error.status === 400) errors = error.errors;
    processFailure({
        dispatch,
        error,
        action: {
            type: requestConst.REQUESTS_FAILURE,
            errors,
        },
    });
    showErrorsIfNeed(error, [400]);
}

function setCurrentEvent(eventName) {
    return {
        type: requestConst.REQUESTS_SET_EVENT,
        eventName,
    };
}

function updateCurrentEventAndUpdateRequests(newEventName) {
    return (dispatch, getState) => {
        const {
            auth: { logined },
            requests: { requests, eventName },
        } = getState();
        if (requests && eventName === newEventName) return;
        if (requests) dispatch(clear());
        dispatch(setCurrentEvent(newEventName));
        console.log('updateCurrentEventAndUpdateRequests', newEventName);
        if (logined) dispatch(getAll());
    };
}

function getAllDelayed(messageServerTS) {
    return (dispatch, getState) => {
        resetRequestTimeout();
        const {
            requests: { requests, eventName },
        } = getState();
        if (eventName) return;
        const currentServerTS = (requests && requests.serverTS) || 0;
        if (messageServerTS && currentServerTS > messageServerTS) return;

        requestTimeout = setTimeout(() => {
            requestTimeout = null;
            const {
                requests: { requests, eventName },
            } = getState();
            if (eventName) return;
            const currentServerTS = (requests && requests.serverTS) || 0;
            if (messageServerTS && currentServerTS > messageServerTS) return;
            console.log('getAllDelayed', currentServerTS, messageServerTS);
            dispatch(getAll());
        }, 2000);
    };
}

function resetRequestTimeout() {
    if (requestTimeout) {
        clearTimeout(requestTimeout);
        requestTimeout = null;
    }
}
